import Vue from 'vue';
import { MutationTree } from 'vuex';
import { UndergradCourseState } from '@/store/undergrad/courses/state';
import { UndergradLive } from '@/models/undergrad/undergrad-live.model';

interface NormalizedCourseLives {
  undergradLives: {
    [key: string]: UndergradLive;
  };
}

const mutations: MutationTree<UndergradCourseState> = {
  SET_UNDERGRAD_COURSES(state: UndergradCourseState, entities: UndergradCourseState) {
    state.undergradCourses = entities.undergradCourses;
  },
  SET_CURRENT_COURSE_ID(state: UndergradCourseState, id: string) {
    state.currentCourseId = id;
  },
  SET_SWITCHING_CURRENT_COURSE(state: UndergradCourseState, isSwitching: boolean) {
    state.isSwitchingCurrentCourse = isSwitching;
  },
  SET_LOADING_COURSE_LIVES(state, payload: { isLoading: boolean; courseId: string }) {
    const { isLoading, courseId } = payload;

    Vue.set(state.isLoadingCourseLives, courseId, isLoading);
  },
  SET_COURSE_LIVES(state, payload: { courseId: string; entities: NormalizedCourseLives }) {
    const {
      entities: { undergradLives },
      courseId,
    } = payload;

    if (!undergradLives) {
      state.undergradCourses[courseId].lives = {};
      return;
    }

    Vue.set(state.undergradCourses, courseId, {
      ...state.undergradCourses[courseId],
      lives: undergradLives,
    });
  },
};

export default mutations;
